import React from 'react';

export default ({ color }) => (
  <svg width="17" height="23" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 11.5L0 23V0z" fill={color || '#fff'} fillRule="evenodd" />
  </svg>
);


// WEBPACK FOOTER //
// ./src/ui/components/generic/IconPlay.js